import { createSlice } from '@reduxjs/toolkit'

import { ICampaignPublicReducers, ICampaignPublicState } from './campaign-public.types'

const initialState: ICampaignPublicState = {
  loading: false,
  error: '',
}

const { actions, reducer } = createSlice<ICampaignPublicState, ICampaignPublicReducers, 'campaign-public'>({
  name: 'campaign-public',
  initialState,
  reducers: {
    getPublicCampaignDetailsByCodeRequest: (state) => {
      state.loading = true
      state.error = ''
    },
    getPublicCampaignDetailsByCodeSuccess: (state, action) => {
      state.loading = false
      state.campaignPublicDetails = action.payload
    },
    getPublicCampaignDetailsByCodeFailure: (state, action) => {
      state.loading = false
      state.error = action.payload.errorMessage
    },
    changeOrderInStock: (state, action) => {
      if (state?.campaignPublicDetails) {
        state.campaignPublicDetails.inStock = action.payload.inStock
      }
    },
  },
})

export { actions as CampaignPublicActions }

export { reducer as campaignPublicReducer }
